const ErrorTexts = {
  required: "Полето е задължително",
};

export const validate = (values, isPage) => {
  const errors = {};

  if (!values.name) {
    errors.name = ErrorTexts.required;
  }

  if (isPage && !values.route) {
    errors.route = ErrorTexts.required;
  }

  // if (!values.activeVersionId) {
  //   errors.activeVersionId = ErrorTexts.required;
  // }

  if (values.futureActiveVersion.id && !values.futureActiveVersion.activeFrom) {
    errors.futureActiveVersion = {
      activeFrom: "Начална дата на бъдеща версия трябва да се попълни",
    };
  }

  if (values.futureActiveVersion.activeFrom && !values.futureActiveVersion.id) {
    errors.futureActiveVersion = {
      activeFrom: "Бъдеща версия трябва да се попълни",
    };
  }

  if (values.futureActiveVersion.activeFrom && values.futureActiveVersion.activeFrom < Date.now()) {
    errors.futureActiveVersion = {
      activeFrom: "Начална дата на бъдеща версия трябва да е в бъдещето",
    };
  }

  values.temporaryVersions.forEach((version, index) => {
    if (!version.id) errors[`temporaryVersions.${index}.id`] = ErrorTexts.required;
    if (!version.activeFrom) errors[`temporaryVersions.${index}.activeFrom`] = ErrorTexts.required;
    if (!version.activeTo) errors[`temporaryVersions.${index}.activeTo`] = ErrorTexts.required;

    if (version.activeFrom && version.activeFrom < Date.now())
      errors[`temporaryVersions.${index}.activeFrom`] = "Датата за начало на временна версия трябва да е в бъдещето";

    if (version.activeTo && version.activeTo < Date.now())
      errors[`temporaryVersions.${index}.activeTo`] = "Датата за край на временна версия трябва да е в бъдещето";

    if (version.activeFrom && version.activeTo && version.activeFrom > version.activeTo)
      errors[`temporaryVersions.${index}.activeTo`] =
        "Датата начало на временна версия трябва да е преди датата за край на временна версия";
  });

  return errors;
};
